// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mn46B","right":"styles_right__2_gKy"};